import React from 'react';
import ProjectPreviewModalArchivedButton from './ProjectPreviewModalArchivedButton';
import { useFileArchiveInfo } from './ProjectPreviewModalContext';

import ProjectPreviewModalRestoringButton from './ProjectPreviewModalRestoringButton';
import ProjectPreviewModalShareButton from './ProjectPreviewModalShareButton';
import { ProjectPreviewModalAction } from './types';

export interface ProjectPreviewModalRestoreButtonProps {
  onAction: (action: ProjectPreviewModalAction) => void;
}

const ProjectPreviewModalRestoreButton: React.FC<ProjectPreviewModalRestoreButtonProps> = ({
  onAction,
}) => {
  const { isFileArchived, isRestoreInProgress } = useFileArchiveInfo();

  if (isFileArchived) {
    return <ProjectPreviewModalArchivedButton />;
  }

  if (isRestoreInProgress) {
    return <ProjectPreviewModalRestoringButton />;
  }

  return <ProjectPreviewModalShareButton onAction={onAction} />;
};

export default ProjectPreviewModalRestoreButton;
